<template>
    <div id="reduce_history">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <div class="reduce-history">
                <!-- 顶部导航 -->
                <div class="history-header">
                    <div class="back-btn" @click="$router.back()">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <h2 class="history-title">AI降痕记录</h2>
                    <div class="header-placeholder"></div>
                </div>

                <!-- 列表内容 -->
                <div class="list-wrap" ref="listWrap" @scroll="handleScroll">
                    <!-- 加载中 -->
                    <div v-if="loading && list.length === 0" class="loading-wrap">
                        <i class="el-icon-loading"></i>
                        <span>加载中...</span>
                    </div>

                    <!-- 空状态 -->
                    <div v-else-if="!loading && list.length === 0" class="empty-wrap">
                        <i class="el-icon-document-delete"></i>
                        <span>暂无降痕记录</span>
                    </div>

                    <!-- 卡片列表 -->
                    <div v-else class="card-list">
                        <div
                            v-for="item in list"
                            :key="item.id"
                            class="history-card"
                            @click="goDetail(item)"
                        >
                            <div class="card-top">
                                <span class="card-type">稿件类型：{{ formatType(item.type) }}</span>
                            </div>
                            <div class="card-tags">
                                <span class="tag tag-version">{{ formatVersion(item.version) }}</span>
                                <span class="tag tag-intensity">{{ formatIntensity(item.level) }}</span>
                            </div>
                            <div class="card-bottom">
                                <span class="word-count">{{ item.textNum || item.length || 0 }}字</span>
                                <span class="create-time">{{ formatTime(item.completed) }}</span>
                            </div>
                        </div>

                        <!-- 加载更多 / 到底了 -->
                        <div class="load-more">
                            <div v-if="loadingMore" class="loading-more">
                                <i class="el-icon-loading"></i>
                                <span>加载中...</span>
                            </div>
                            <div v-else-if="noMore" class="no-more">
                                — 到底了 —
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import top from '../components/top.vue'
import api from '@/api/api'
export default {
    components: { top },
    data() {
        return {
            mianH: 0,
            list: [],
            pageNum: 1,
            pageSize: 100,
            loading: false,
            loadingMore: false,
            noMore: false,
            // 映射表（与 DeAiRate.vue 保持一致）
            typeMap: {
                'novel': '小说',
                'script': '剧本',
                'media': '公众号'
            },
            versionMap: {
                'v2': '偏向低AI率',
                'v3': '偏向自然表达'
            },
            intensityMap: {
                1: '极低',
                2: '低',
                3: '中',
                4: '高',
                5: '极高'
            }
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
        this.fetchList();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        // 获取列表
        fetchList() {
            if (this.loading) return;
            this.loading = true;
            api.reduceList( {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }).then((res) => {
                if (res.code === 200 && res.data) {
                    const rows = res.data.list || res.data.rows || res.data || [];
                    if (this.pageNum === 1) {
                        this.list = rows;
                    } else {
                        this.list = this.list.concat(rows);
                    }
                    // 判断是否还有更多
                    const total = res.data.total || 0;
                    this.noMore = this.list.length >= total || rows.length < this.pageSize;
                } else {
                    this.$message.warning(res.msg || '获取列表失败');
                }
            }).catch((err) => {
                console.error('获取降痕记录失败', err);
                this.$message.error('获取列表失败，请稍后重试');
            }).finally(() => {
                this.loading = false;
                this.loadingMore = false;
            });
        },
        // 滚动加载更多
        handleScroll() {
            if (this.loadingMore || this.noMore) return;
            const wrap = this.$refs.listWrap;
            if (!wrap) return;
            const scrollBottom = wrap.scrollHeight - wrap.scrollTop - wrap.clientHeight;
            if (scrollBottom < 60) {
                this.loadingMore = true;
                this.pageNum++;
                this.fetchList();
            }
        },
        // 映射显示
        formatType(type) {
            return this.typeMap[type] || type || '未知';
        },
        formatVersion(version) {
            return this.versionMap[version] || version || '';
        },
        formatIntensity(level) {
            return this.intensityMap[level] || (level ? String(level) : '');
        },
        // 格式化时间
        formatTime(time) {
            if (!time) return '';
            const d = new Date(time);
            if (isNaN(d.getTime())) return time;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const h = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            const s = String(d.getSeconds()).padStart(2, '0');
            return `${y}-${m}-${day} ${h}:${min}:${s}`;
        },
        // 点击卡片跳转详情（可选）
        goDetail(item) {
            // 可跳转详情页或返回编辑页回填
            this.$router.push({
                path: '/reduceDetial',
                query: { id: item.logId }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
#reduce_history {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
    overflow: hidden;
}

#reduce_history .mian {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    overflow: hidden;
    flex: 1;
    min-height: 0;
}

.reduce-history {
    width: 1000px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    // 顶部导航
    .history-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        flex-shrink: 0;
    }

    .back-btn {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;
        transition: background 0.2s;

        &:hover {
            background: rgba(0, 0, 0, 0.04);
        }

        i {
            font-size: 18px;
            color: #333;
            font-weight: bold;
        }
    }

    .history-title {
        font-size: 26px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0;
    }

    .header-placeholder {
        width: 32px;
    }

    // 列表区域
    .list-wrap {
        flex: 1;
        overflow-y: auto;
        padding: 0 16px 16px;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 2px;
        }
    }

    // 加载中
    .loading-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 0;
        gap: 12px;
        color: #999;
        font-size: 14px;

        i {
            font-size: 28px;
            color: #c0a062;
        }
    }

    // 空状态
    .empty-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 0;
        gap: 12px;
        color: #c0c4cc;
        font-size: 14px;

        i {
            font-size: 48px;
        }
    }

    // 卡片列表
    .card-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .history-card {
        background: #fff;
        border-radius: 12px;
        padding: 16px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        cursor: pointer;
        transition: transform 0.15s, box-shadow 0.15s;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .card-top {
        margin-bottom: 10px;
    }

    .card-type {
        font-size: 16px;
        font-weight: 600;
        color: #1a1a1a;
    }

    .card-tags {
        display: flex;
        gap: 8px;
        margin-bottom: 12px;
    }

    .tag {
        display: inline-block;
        padding: 3px 10px;
        font-size: 12px;
        color: #666;
        background: #f5f5f5;
        border-radius: 6px;
        line-height: 1.4;
    }

    .card-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
        border-top: 1px solid #f0f0f0;
    }

    .word-count {
        font-size: 13px;
        color: #333;
        font-weight: 500;
    }

    .create-time {
        font-size: 13px;
        color: #b8965a;
        font-weight: 500;
    }

    // 加载更多
    .load-more {
        padding: 16px 0;
        text-align: center;
    }

    .loading-more {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-size: 13px;
        color: #999;

        i {
            font-size: 16px;
        }
    }

    .no-more {
        font-size: 12px;
        color: #ccc;
    }
}

// =====================================================
//  响应式：小屏幕调整
// =====================================================
@media (max-width: 768px) {
    #reduce_history .mian {
        padding-top: 0;
    }

    .reduce-history {
        .history-header {
            padding: 10px 12px;
        }

        .history-title {
            font-size: 16px;
        }

        .list-wrap {
            padding: 0 12px 12px;
        }

        .history-card {
            padding: 14px;
            border-radius: 10px;
        }

        .card-type {
            font-size: 15px;
        }
    }
}

@media (max-width: 480px) {
    .reduce-history {
        .history-header {
            padding: 8px 10px;
        }

        .history-title {
            font-size: 15px;
        }

        .list-wrap {
            padding: 0 10px 10px;
        }

        .history-card {
            padding: 12px;
            border-radius: 10px;
        }

        .card-type {
            font-size: 14px;
        }

        .card-bottom {
            padding-top: 8px;
        }

        .word-count,
        .create-time {
            font-size: 12px;
        }
    }
}
</style>
